import ApiService from '@/services/api.service'

const UserTplService = {

    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/UserRoleHeaders/",
            headers: {
            },
            params: { 
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,          
              PageNumber : parameter.PageNumber            
            }
          }     
          return ApiService.customRequest(requestData);       
    },

    getTplByCode(parameter){
      const requestData = {
        method: 'get',
        url: "/UserRoleHeaders/",
        headers: {
        },
        params: {          
          code: parameter.code           
        }
      }     
      return ApiService.customRequest(requestData);       
    },

    get(id) {
      return ApiService.get(`/UserRoleHeaders/${id}`);
    },

    delete(id){
      return ApiService.delete(`/UserRoleHeaders/${id}`)
    },

    add(data){
      return ApiService.post(`/UserRoleHeaders`,data)
    },

    update(id,data){
      return ApiService.put(`/UserRoleHeaders/${id}`,data)
    },

    addPermision(data){
      return ApiService.post(`/UserRoleDetails`,data)
    },

    updatePermision(id,data){
      return ApiService.put(`/UserRoleDetails/${id}`,data)
    },
    getUserByCode(id){
      //return ApiService.get(`/Users/${id}`);     
      const requestData = {
        method: 'get',
        url: "/Users/",
        headers: {
        },
        params: {          
          Code: id        
        }
      }     
      return ApiService.customRequest(requestData);        
    },


    getDataSource(type,code){
      if (code)
        return ApiService.get(`/UserRoleDetails/Menu?Device=WEB&Module=${type}&RoleCode=${code}&Operation=EditingRole`);
      return ApiService.get(`/UserRoleDetails/Menu?Device=WEB&Module=${type}&Operation=CreatingRole`);
    },

    getProviders(id, includeTraining = false){
      if (id) {
        const path = `/UserRoleHeaders/${includeTraining ? 'AvailableProviders/': ''}${id}`;
        return ApiService.get(path); 
      } else {
        return ApiService.get(`/UserRoleHeaders/Providers?AvailableProviders=${includeTraining}`); }
    },

    getProvidersTypes(){
      return ApiService.get(`/Providers/Types`);
    },

    getClinicalNotesAssignment(id) {
        return ApiService.get(`/UserRoleDetails/ClinicalNotesAssignment/${id}`);
    },

    getExcludeCosigner(id) {
        return ApiService.get(`/UserRoleDetails/ExcludeCosigner/${id}`);
    },

    getNeedingCosigner(id) {
        return ApiService.get(`/UserRoleDetails/NeedingCosigner/${id}`);
    },

    getEHRFeatures(id) {
        return ApiService.get(`/UserRoleDetails/EHRFeatures/${id}`);
    },

    getCustomExport(id) {
        return ApiService.get(`/UserRoleDetails/CustomExport/${id}`);
    },

    updateClinicalNotesAssignment(id, data) {
        return ApiService.put(`/UserRoleDetails/ClinicalNotesAssignment/${id}`,data)
    },

    updateExcludeCosigner(id, data) {
        return ApiService.put(`/UserRoleDetails/ExcludeCosigner/${id}`,data)
    },

    updateNeedingCosigner(id, data) {
        return ApiService.put(`/UserRoleDetails/NeedingCosigner/${id}`,data)
    },

    updateEHRFeatures(id, data) {
        return ApiService.put(`/UserRoleDetails/EHRFeatures/${id}`,data)
    },

    updateCustomExport(id, data) {
        return ApiService.put(`/UserRoleDetails/CustomExport/${id}`,data)
    },

    clone(id, data){
        return ApiService.post(`/UserRoleDetails/Clone/${id}`,data)
    },
}

export default UserTplService;